import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ProductCompareService {
    private readonly MAX_COMPARE = 3;

    private selectedIdsSubject = new BehaviorSubject<number[]>([]);
    // eslint-disable-next-line @typescript-eslint/member-ordering
    selectedIds$ = this.selectedIdsSubject.asObservable();

    toggle(productId: number): void {
        const selected = this.selectedIdsSubject.value;

        if (selected.includes(productId)) {
            this.selectedIdsSubject.next(selected.filter((id) => id !== productId));
            return;
        }

        if (selected.length >= this.MAX_COMPARE) {
            return;
        }

        this.selectedIdsSubject.next([...selected, productId]);
    }

    isSelected(productId: number): boolean {
        return this.selectedIdsSubject.value.includes(productId);
    }

    getSelected(): number[] {
        return this.selectedIdsSubject.value;
    }

    clear(): void {
        this.selectedIdsSubject.next([]);
    }
}
